import { FC } from "react";
import useCountdown from "../../../hooks/countdown/useCountdown";
import { BULLETIN_DATE } from "../../../utils/constants";
import { Flex, Heading } from "@chakra-ui/react";
import CountdownTime from "../../../components/organism/AlertDateCountdown/CountdownTime";
import VerticalLine from "../../../components/atom/Line/VerticalLine";
import SpinnerComponent from "../../../components/atom/Spinner/SpinnerComponent";

const CountDownDashboard: FC = () => {
  const { timeLeft, targetMonthYear } = useCountdown(
    BULLETIN_DATE,
    "Geração automática do próximo boletim",
  );

  const isLoading =
    timeLeft.days === 0 &&
    timeLeft.hours === 0 &&
    timeLeft.minutes === 0 &&
    timeLeft.seconds === 0;

  return (
    <Flex direction="row" gap={4} alignItems="center">
      <Heading as="h4" fontSize="xl" fontWeight="bold" color="white">
        {targetMonthYear}
      </Heading>
      {isLoading ? (
        <SpinnerComponent size="xl" />
      ) : (
        <Flex direction="row" alignItems="center">
          <CountdownTime
            value={timeLeft.days}
            label="Dias"
            fontSize="3xl"
            fontColor="white"
            labelSize="md"
          />
          <VerticalLine height="16" marginX="4" />
          <CountdownTime
            value={timeLeft.hours}
            label="Horas"
            fontSize="3xl"
            labelSize="md"
          />
          <VerticalLine height="16" marginX="4" />
          <CountdownTime
            value={timeLeft.minutes}
            label="Min"
            fontSize="3xl"
            labelSize="md"
          />
          <VerticalLine height="16" marginX="4" />
          <CountdownTime
            value={timeLeft.seconds}
            label="Seg"
            fontSize="3xl"
            labelSize="md"
          />
        </Flex>
      )}
    </Flex>
  );
};

export default CountDownDashboard;
